var OnetrustActiveGroups = window.OnetrustActiveGroups || '';
var sheerId = window.sheerId || {};

(function ($, site, Optanon) {
  Drupal.behaviors.SheerIDBlockV1 = {
    getButtons: function ($module) {
      var $triggers = $('.js-elc-button', $module);

      if ($triggers.length > 0) {
        $triggers = $triggers.get(0);
      }

      return $triggers;
    },

    getImage: function ($module) {
      var $triggers = $('.js-sheerid-block-link-image', $module);

      if ($triggers.length > 0) {
        $triggers = $triggers.get(0);
      }

      return $triggers;
    },

    attach: function (context, settings) {
      var self = this;
      var $modules = $('.js-sheerid-block--v1', context);

      $modules.each(function () {
        self.init($(this), settings);
      });
    },

    init: function ($module, settings) {
      // Check for onetrust/optanon/onetrustgroups to determine if we need, have or denied consent.
      var cookieAllowedOrIgnored = () => {
        return (
          !settings.onetrust_enabled ||
          (OnetrustActiveGroups && OnetrustActiveGroups.includes(',3,'))
        );
      };
      var cookieConsentChangeCallback = () => {
        var self = this;

        if (cookieAllowedOrIgnored()) {
          self.render($module);
        }
      };

      if (Optanon) {
        Optanon.OnConsentChanged(cookieConsentChangeCallback);
      }
      site.elcEvents.addListener('onetrust:loaded', cookieConsentChangeCallback);
      cookieConsentChangeCallback();
    },

    render: function ($module) {
      var that = this;
      var verificationUrl = $module.find('.js-verification')?.data('verificationUrl');
      var $elementsToListen = $();

      $elementsToListen.push(that.getButtons($module));
      $elementsToListen.push(that.getImage($module));

      $elementsToListen.once().on('click.sheerID', function (e) {
        e.preventDefault();
        if (typeof sheerId?.loadInModal === 'function') {
          sheerId.loadInModal(verificationUrl, { mobileRedirect: true });
        }
      });

      $module.removeClass('hidden');
    }
  };
})(jQuery, window.site || {}, window.Optanon);
